export const CASES = 'cases';
export const CASE = 'case';



// WEBPACK FOOTER //
// src/store/modules/cases/mutation-types.js